<template>
  <ion-page>
    <master-layout pageTitle="مدیریت انبار">
      <div class="p-3">
        <button class="btn btn-info btn-clear-filters" @click="filter = {}">پاک کردن فیلتر ها</button><br>
        <label>انتخاب برند</label>
        <select class="form-control mb-2" v-model="filter.brand">
          <option v-for="item in brands" :key="item._id" :value="item._id">{{item.title}}</option>
        </select>
        <label>انتخاب دسته بندی</label>
        <select class="form-control" v-model="filter.category">
          <option v-for="item in categories" :key="item._id" :value="item._id">{{item.title}}</option>
        </select>
      </div>
        <DataTable :functions="functions" :show-last-label="true" v-if="pageIsLoaded" card="true" auto-reload="1"  :headers="headers" :route="route"></DataTable>

      <ModalComponent ref="modal" modal-title="تصویر محصول" :is-open="isModalOpen" @close="isModalOpen = false" >
        <img :src="product_pic_url" alt="" style="width: 100%;height: 100%;object-fit: contain">
      </ModalComponent>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonPage,
} from "@ionic/vue";
import ModalComponent from "@/components/ModalComponent.vue";
import {AppApi} from "@/api/AppApi";


export default {
  components: {
    DataTable, IonPage,ModalComponent,
  },
  data()
  {
    return {
      isModalOpen: false,
      warehouseLoaded: false,
      warehouses: [],
      pagePath : this.$route.path,
      showModal : false,
      product_pic_url : '',
      headers: [
          'تصویر',
        'عنوان',
        'ویژگی',
        'موجودی',
        'موجودی واحد بزرگتر',
      ],
      functions : [{name : 'showPic',method: this.showPic}],
      route:'warehouseProduct/ListAjax',
      pageIsLoaded : false,
      brands : [],
      categories : [],
      filter : {brand : null,category:null},
    };
  },
  mounted()
  {
    AppApi.getAllProductBrandsForSelect().then((result)=>{
      if (result.ok)
        this.brands = result.brands;
    });
    AppApi.getAllProductCategoryForSelect().then((result)=>{
      if (result.ok)
        this.categories = result.categories;
    });
  },
  methods :{
    async initPage()
    {
      const result = await AppApi.getCustomerGroups();
      if (result.ok)
      {
        const groups = result.groups;
        for (let i =0;i<groups.length;i++)
        {
          this.headers.push(groups[i].title);
        }
      }
      this.pageIsLoaded = true;

    },
    showPic(url)
    {
      this.product_pic_url = url;
      this.isModalOpen = true;
    },
    async changeFilter()
    {
      let route = 'warehouseProduct/ListAjax?t=1';
      const filter = this.filter;
      if (filter.brand)
        route += '&brand_id='+filter.brand;
      if (filter.category)
        route += '&cat_id='+filter.category;
      this.route = route;
    }
  },

  watch : {
    '$route.fullPath':{
      handler()
      {
        if (this.pagePath == this.$route.path)
          this.initPage();
      },deep : true,immediate : true
    },
    filter : {
      handler()
      {
        this.changeFilter();
      },deep : true
    }
  }
};
</script>

<style scoped>
.p-3
{
  padding: 8px;
}
.mb-2
{
  margin-bottom: 8px;
}
</style>